import React, {useMemo} from "react";
import {useTranslation} from "react-i18next";
import moment from "moment";
import {StyledTable} from "./CourierEquipmentInformations.styled";

export const CourierEquipmentInformations = ({courierEquipments}) => {
    const {t} = useTranslation(["courierDetail"]);

    const columns = [
        {
            title: t("fields.equipmentName"),
            dataIndex: "equipmentName",
            key: "equipmentName",
            onCell: () => ({
                "data-label": t("fields.equipmentName")
            }),
            render: text => text || "-"
        },
        {
            title: t("fields.equipmentColor"),
            dataIndex: "equipmentColor",
            key: "equipmentColor",
            onCell: () => ({
                "data-label": t("fields.equipmentColor")
            }),
            render: text => text || "-"
        },
        {
            title: t("fields.equipmentSize"),
            dataIndex: "equipmentSize",
            key: "equipmentSize",
            onCell: () => ({
                "data-label": t("fields.equipmentSize")
            }),
            render: text => text || "-"
        },
        {
            title: t("fields.equipmentPrice"),
            dataIndex: "price",
            key: "price",
            onCell: () => ({
                "data-label": t("fields.equipmentPrice")
            }),
            render: text => text || "-"
        },
        {
            title: t("fields.equipmentHandoverDate"),
            dataIndex: "handoverDate",
            key: "handoverDate",
            onCell: () => ({
                "data-label": t("fields.equipmentHandoverDate")
            }),
            render: date => (date ? moment(date).format("DD.MM.YYYY HH:mm") : "-")
        },
        {
            title: t("fields.equipmentReturnDate"),
            dataIndex: "returnDate",
            key: "returnDate",
            onCell: () => ({
                "data-label": t("fields.equipmentReturnDate")
            }),
            render: date => (date ? moment(date).format("DD.MM.YYYY HH:mm") : "-")
        },
        {
            title: t("fields.equipmentStatusValue"),
            dataIndex: "status",
            key: "status",
            onCell: () => ({
                "data-label": t("fields.equipmentStatusValue")
            }),
            render: text =>
                //text === "handovered" ? "Teslim Edildi" : "returned" ? "İade Edildi" : text || "-"
                text === "returned"
                    ? "İade Edildi"
                    : text === "handovered"
                    ? "Teslim Edildi"
                    : text === "pendingAssignment"
                    ? "Atama Beklemede"
                    : text || "-"
        }
    ];

    const tableData = useMemo(() => {
        return (courierEquipments?.length > 0 ? courierEquipments : []).map((equipment, index) => ({
            key: equipment?._id || index,
            equipmentName: equipment?.equipmentName,
            equipmentType: equipment?.equipmentType,
            equipmentSize: equipment?.equipmentSize,
            price: equipment?.price,
            equipmentColor: equipment?.equipmentColor,
            handoverDate: equipment?.handoverDate,
            returnDate: equipment?.returnDate,
            status: equipment?.status
        }));
    }, [courierEquipments]);

    if (courierEquipments?.length === 0) {
        return <div>{t("noInfoToDisplay", {ns: "courierDetail"})}</div>;
    }

    return <StyledTable columns={columns} dataSource={tableData} pagination={false} />;
};
